//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/ObjectSelector.js";
import "../no/ObjectSelector.js";
let d=[[[0,"AngularTolerance",1,0],[0,"AttributeCategories",1,0],[0,"Attributes",1,0],[0,"ChordalTolerance",1,0],[0,"ChordalToleranceMethodOption",1,0],[0,"ExportFrom",1,0],[1,"ExportSelectionBlock",0,"ObjectSelector",0],[0,"ExportUnits",1,0],[0,"ExportUserDefinedAttributes",1,0],[0,"FileSaveFlag",1,0],[0,"IfcFileFormat",1,0],[0,"IncludeOrExcludeAttributeCategories",1,0],[0,"IncludeOrExcludeAttributes",1,0],[0,"InputFile",1,0],[0,"RelativeChordalTolerance",1,0],[0,"SettingsFile",1,0],[0,"TessellationMethodOption",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.IfcCreator = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.IfcCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.IfcCreator.ExportFromOption = Object.freeze({
    "DisplayPart" : "DisplayPart", "ExistingPart" : "ExistingPart"});

SPLM.IfcCreator.IfcFormatEnum = Object.freeze({
    "IFC2x3" : "IFC2x3", "Ifc4" : "Ifc4"});

SPLM.IfcCreator.UnitsEnum = Object.freeze({
    "Millimeters" : "Millimeters", "Inches" : "Inches", "Meters" : "Meters", "Microns" : "Microns"});

SPLM.IfcCreator.IncludeOrExcludeAttributeCategoriesEnum = Object.freeze({
    "Include" : "Include", "Exclude" : "Exclude"});

SPLM.IfcCreator.IncludeOrExcludeAttributesEnum = Object.freeze({
    "Include" : "Include", "Exclude" : "Exclude"});

SPLM.IfcCreator.TessellationMethodOptionEnum = Object.freeze({
    "LightWeightRepresentation" : "LightWeightRepresentation", "SpecifyTolerances" : "SpecifyTolerances"});

SPLM.IfcCreator.ChordalToleranceMethodOptionEnum = Object.freeze({
    "Relative" : "Relative", "Absolute" : "Absolute"});

export default SPLM;